<template>
  <div class="board-view-child-card">
    <div class="card-child-list">
      <ChildCardPreviewContent
        v-for="id in cardsIds"
        :key="id"
        :card-id="id"
        :parent-card-id="parentCardId"
        :list-cards="cardsIds"
      />
    </div>
  </div>
</template>

<script>
import ChildCardPreviewContent from '@/components/widgets/ChildCardPreviewContent';

export default {
  name: 'ChildCardsPreview',

  components: {
    ChildCardPreviewContent,
  },

  props: {
    cardsIds: {
      type: Array,
      required: true,
    },

    parentCardId: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.board-view-child-card {
  z-index: 1;

  .card-child-list {
    display: flex;
    flex-direction: column;
    margin-bottom: 4px;
  }
}
</style>
